import {createReducer, on} from '@ngrx/store';
import * as UpdateOrganizationActions from '../actions/update-organization.actions';
import {Organization} from '../../../services/api/organizations/models/organization.model';

export const updateOrganizationFeatureKey = 'updateOrganization';

export interface State {
  record: Organization | null;
  error: any | null;
  loaded: boolean;
  loading: boolean;
}

export const initialState: State = {
  record: null,
  error: null,
  loaded: false,
  loading: false
};


export const reducer = createReducer(
  initialState,

  on(UpdateOrganizationActions.updateOrganization, (state: State): State => ({
    ...state,
    error: null,
    loaded: false,
    loading: true
  })),
  on(UpdateOrganizationActions.updateOrganizationSuccess, (_state: State, action: { data: Organization }): State => ({
    record: action.data,
    error: null,
    loaded: true,
    loading: false
  })),
  on(UpdateOrganizationActions.updateOrganizationFailure, (_state: State, action: { error: unknown }): State => ({
    record: null,
    error: action.error,
    loaded: false,
    loading: false
  })),
  on(UpdateOrganizationActions.clearUpdateOrganizationState, (): State => ({
    record: null,
    error: null,
    loaded: false,
    loading: false
  }))
);

